import { LOOP_FACETS } from './loop54Facets';

export const filterTypes = {
  [LOOP_FACETS.PRODUCT_MARKING]: 'Märkningar',
  [LOOP_FACETS.RECIPE_MARKING]: 'Märkningar',
  [LOOP_FACETS.Brands]: 'Varumärken',
  [LOOP_FACETS.COOKING_TIMES]: 'Tillagningstid'
};
